import { Link } from "react-router-dom";
import Seo from "../seo/Seo";
import { PAGE_SEO } from "../seo/pages";

export default function NotFound() {
  return (
    <main className="mx-auto flex min-h-[70vh] max-w-xl flex-col items-center justify-center px-5 text-center">
      <Seo {...PAGE_SEO.notFound} path="/404" noindex />
      <h1 className="font-heading text-4xl font-extrabold text-[#0E1726]">Page not found</h1>
      <p className="mt-3 text-slate-600">That page doesn't exist or has moved.</p>
      <Link to="/" className="mt-6 rounded-full bg-[#1F7BE0] px-6 py-3 font-bold text-white">
        Back to home
      </Link>
    </main>
  );
}